import { ToastContainer } from "react-toastify";
import {
    CheckCircleIcon,
    ExclamationCircleIcon,
    ExclamationTriangleIcon,
    InformationCircleIcon,
    XMarkIcon,
} from "@heroicons/react/24/outline";

const contextClass = {
    info: "border-blue-600 bg-blue-900-40 text-blue-25",
    error: "border-red-300 bg-red-600-40 text-red-100",
    warning: "border-orange-500 bg-orange-800-40 text-orange-100",
    success: "border-emerald-700 bg-emerald-950-40 text-emerald-25",
    default: "border-darkgreen-200 bg-darkgreen-500/40 text-darkgreen-100",
};

export const Notification = () => {
    return (
        <ToastContainer
            position="bottom-right"
            icon={({ type }) => {
                switch (type) {
                    case "info":
                        return (
                            <InformationCircleIcon className="size-6 shrink-0 stroke-2" />
                        );
                    case "error":
                        return (
                            <ExclamationCircleIcon className="size-6 shrink-0 stroke-2" />
                        );
                    case "success":
                        return (
                            <CheckCircleIcon className="size-6 shrink-0 stroke-2" />
                        );
                    case "warning":
                        return (
                            <ExclamationTriangleIcon className="size-6 shrink-0 stroke-2" />
                        );
                    default:
                        return null;
                }
            }}
            closeButton={({ closeToast }) => (
                <button type="button" onClick={closeToast}>
                    <XMarkIcon className="size-6 cursor-pointer stroke-2 opacity-75 hover:opacity-100" />
                </button>
            )}
            toastClassName={(context) =>
                contextClass[context?.type || "default"] +
                " gap-2 relative flex p-3 min-h-12 md:mb-3 rounded-none text-base w-full md:rounded-3xl justify-between overflow-hidden cursor-pointer *:me-0! border"
            }
            progressClassName={({ type }) => {
                const baseClasses =
                    "Toastify__progress-bar Toastify__progress-bar--animated";

                switch (type) {
                    case "info":
                        return `${baseClasses} bg-blue-600`;

                    case "error":
                        return `${baseClasses} bg-red-300`;

                    case "success":
                        return `${baseClasses} bg-emerald-700`;

                    case "warning":
                        return `${baseClasses} bg-orange-500`;

                    default:
                        return `${baseClasses} bg-darkgreen-200`;
                }
            }}
        />
    );
};
